import React from 'react'
import PropTypes, { string } from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const configs = {
  types: ['inverse'],
  modifiers: [
    'xxs',
    'xs',
    'sm',
    {
      title: 'md',
      isDefault: true
    },
    'lg',
    'xl',
    'xxl'
  ]
}

function Heading(props) {
  const {
    children,
    tag,
    xxs,
    xs,
    sm,
    md,
    xl,
    lg,
    xxl,
    inverse,
    ...rest
  } = props
  const CustomTag = tag || 'h1'

  return (
    <CustomTag {...rest} className={resolveProps(props, configs, 'Heading')}>
      {children}
    </CustomTag>
  )
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  tag: PropTypes.string,
  xxs: PropTypes.bool,
  xs: PropTypes.bool,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  xl: PropTypes.bool,
  xxl: PropTypes.bool,
  inverse: PropTypes.bool,
  configs: PropTypes.shape({
    types: PropTypes.arrayOf(string),
    modifiers: PropTypes.array
  })
}
export default Heading
